import React, { Component } from 'react';
import { InstantSearch, Hits, SearchBox } from 'react-instantsearch-dom';
import MentorCard from './MentorCard';
import LazyLoad from 'react-lazyload';

class Search extends Component {

    getMentorCard({ hit }) {
        return (
            <LazyLoad height={200} offset={[-100, 0]}>
            <div>
                <MentorCard mentorName={hit.mentorName}
                            mentorTitle={hit.mentorTitle}
                            mentorEmail={hit.mentorEmail}
                            mentorMessage={hit.mentorMessage}
                            mentorTwitter={hit.mentorTwitter}/>
            </div>
            </LazyLoad>
        );

    }

    render() {
        return (
            <InstantSearch
                appId="4978AMB399"
                apiKey="f501a25d65f1999a83c41d841d9194fe"
                indexName="prod_MENTORLIST">
                <div className="container">
                    <SearchBox autoFocus={true} showLoadingIndicator={true} />
                    <br />
                    <Hits hitComponent={this.getMentorCard} />
                </div>
            </InstantSearch>
        );
    }

    componentDidMount() {
        {
            document.querySelector("input[type='search']").placeholder = "Search by name, occupation, description..."
        }
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js